import script from "./QuizQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizQuestion.vue?vue&type=script&setup=true&lang=js"

import "./QuizQuestion.vue?vue&type=style&index=0&id=40c1fa00&lang=scss"

const __exports__ = script;

export default __exports__